<template>
  <div>
    <app-contentpageheader>
      <b-img
        slot="entrySectionImage"
        fluid
        alt="Responsive image"
        :src="backgroundImg"
      />
      <h3 slot="entrySectionText">Deski podłogowe klasyczne</h3>
    </app-contentpageheader>
    <app-classic />
    <app-footer />
  </div>
</template>
<script>
import ContentPageHeader from "../../components/common/ContentPageHeader.vue";

import Classic from "../../components/collections/types/Classic.vue";
import Footer from "../../components/common/Footer.vue";
export default {
  data() {
    return {
      backgroundImg: require("../../assets/common/wood.jpg")
    };
  },
  components: {
    "app-classic": Classic,
    "app-footer": Footer,
    "app-contentpageheader": ContentPageHeader
  }
};
</script>
